import type TableQuery from "./TableQuery";
import { type TableQueryType } from "./TableQuery";
import type SortBy from "./SortBy";
import { type SortColumn } from "./SortBy";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";
import type { MailboxInfo } from "owa-client-types";

export interface CopilotResultsTableQuery extends TableQuery {
    sortBy: SortBy;
    mailboxInfo: MailboxInfo;
}

// Fixed sort configuration for Copilot Results - always sort by Date descending (newest first)
// Users cannot change this sort setting as the sort UI is hidden for Copilot Results tables
const COPILOT_RESULTS_SORT_BY: SortBy = {
    sortColumn: 1,
    sortDirection: "Descending",
};

export function createCopilotResultsTableQuery(mailboxInfo: MailboxInfo): CopilotResultsTableQuery {
    return {
        folderId: "CopilotResultsFolder", // [TODO: sopai, asarangi]: Copilot Results do not belong to any specific folder but we will want to make this unique per prompt in the future
        listViewType: 1, // Force into Item view as we only have access to ItemIds from Bizchat results
        type: 4,
        sortBy: COPILOT_RESULTS_SORT_BY,
        mailboxInfo,
    };
}

export function isCopilotResultsTable(tableQuery: TableQuery | undefined): boolean {
    if (!tableQuery) {
        return false;
    }
    return tableQuery.type === 4;
}
